import React from "react"
import { PhotoProvider, PhotoConsumer } from "react-photo-view"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from "react-slick"
import ArrowLeftIcon from "../../../../icons/arrow-left.svg"

import { Link } from "gatsby"

const DefaultVariant = ({ images, lightbox }) => {
  const slickSettings = {
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    rows: 2,
    slidesPerRow: 1,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
        },
      },

      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className="-m-1 mx-auto max-w-[400px] sm:max-w-3xl md:-m-2 md:max-w-full">
      {lightbox ? (
        <PhotoProvider>
          <Slider
            {...slickSettings}
            arrows={true}
            prevArrow={<ArrowLeft />}
            nextArrow={<ArrowRight />}
            className="mx-auto "
          >
            {images &&
              images?.map(gallery =>
                gallery?.defaultGallery?.map((image, index) => {
                  const gatsbyImage =
                    image?.defaultImage &&
                    getImage(image?.defaultImage?.gatsbyImage)
                  if (!gatsbyImage) {
                    return null
                  }
                  return image?.link?.url ? (
                    <Link
                      key={index}
                      to={image?.link?.url}
                      className="flex flex-wrap justify-center border-none p-1 focus:outline-none md:p-2"
                    >
                      <GatsbyImage
                        alt={image?.altText || ""}
                        image={gatsbyImage}
                        objectFit={"contain"}
                        className="h-[200px] w-[250px] cursor-pointer rounded-[4px] md:h-[232px] md:w-[295px]"
                      />
                    </Link>
                  ) : (
                    <PhotoConsumer
                      key={index}
                      src={gatsbyImage?.images?.fallback?.src}
                    >
                      <div className="flex flex-wrap justify-center border-none p-1 focus:outline-none md:p-2">
                        <GatsbyImage
                          objectFit={"contain"}
                          alt={image?.altText || ""}
                          image={gatsbyImage}
                          className="h-[200px] w-[250px] cursor-pointer rounded-[4px] md:h-[232px] md:w-[295px]"
                        />
                      </div>
                    </PhotoConsumer>
                  )
                })
              )}
          </Slider>
        </PhotoProvider>
      ) : (
        <Slider
          {...slickSettings}
          arrows={true}
          prevArrow={<ArrowLeft />}
          nextArrow={<ArrowRight />}
          className="mx-auto "
        >
          {images &&
            images?.map(gallery =>
              gallery?.defaultGallery?.map((image, index) => {
                const gatsbyImage =
                  image?.defaultImage &&
                  getImage(image?.defaultImage?.gatsbyImage)
                if (!gatsbyImage) {
                  return null
                }
                return (
                  <Link
                    to={image?.link?.url}
                    className="focus:outline-none"
                    key={index}
                  >
                    <div className="flex flex-wrap justify-center border-none p-1 focus:outline-none md:p-2">
                      <GatsbyImage
                        alt={image?.altText || ""}
                        image={gatsbyImage}
                        className="h-[200px] w-[250px] rounded-[4px] md:h-[232px] md:w-[295px]"
                      />
                    </div>
                  </Link>
                )
              })
            )}
        </Slider>
      )}
    </div>
  )
}

export default DefaultVariant

const ArrowLeft = ({ ...rest }) => {
  return (
    <button
      {...rest}
      className="absolute left-0 top-0 bottom-0 z-50 h-full md:left-[-12px] "
    >
      <ArrowLeftIcon className="relative  h-[18px] w-[10px] md:h-[32px] md:w-[18px] " />
    </button>
  )
}

const ArrowRight = ({ ...rest }) => {
  return (
    <button
      {...rest}
      className="absolute right-0 top-0 bottom-0 z-50 h-full md:right-[-12px] "
    >
      <ArrowLeftIcon className="relative h-[18px] w-[10px] rotate-180 md:h-[32px] md:w-[18px]" />
    </button>
  )
}
